import { atom } from "jotai";
import { Instrument } from "./../types/Instrument";

export const InstrumentStateAtom = atom<Instrument[]>([]);
